// eslint-disable-next-line import/prefer-default-export
export function getTotal(count) {
  return `${count} ${count === 1 ? "record" : "records"}`;
}
